import { toast } from '@foam/buoy/src/components/Toast/Toast';
import { useShareMediaKit } from '~/hooks/api/media-kits/share';

const PLAIN_TEXT_MIME_TYPE = 'text/plain';

const toSharedMediaKitUrl = (token: string) =>
  `${window.location.origin}/shared/media-kits/${token}`;

const writeDeferredTextToClipboard = (text: Promise<string>) => {
  if (typeof ClipboardItem === 'function' && navigator.clipboard.write) {
    return navigator.clipboard.write([
      new ClipboardItem({
        [PLAIN_TEXT_MIME_TYPE]: text.then(
          (value) => new Blob([value], { type: PLAIN_TEXT_MIME_TYPE }),
        ),
      }),
    ]);
  }

  return text.then((value) => navigator.clipboard.writeText(value));
};

export const useCopyMKLink = (id: string) => {
  const shareMediaKit = useShareMediaKit();

  const copyMkLink = () => {
    const sharedMediaKitUrl = shareMediaKit
      .mutateAsync(id)
      .then(({ token }) => toSharedMediaKitUrl(token));

    return writeDeferredTextToClipboard(sharedMediaKitUrl)
      .then(() => {
        toast('Link successfully copied', { variant: 'success' });
      })
      .catch(() => {
        toast('Failed to copy link', { variant: 'alert' });
      });
  };

  return { copyMkLink };
};
